import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './presetTag.module.scss';

interface IPresetTagProps {
  children: ReactNode,
  isActive?: boolean,
  className?: string,
  activeClassName?: string,
  onClick?: () => void,
  dataTest?: string,
}

const PresetTag = ({
  children,
  isActive = false,
  className,
  activeClassName,
  onClick,
  dataTest = 'presetTag',
}: IPresetTagProps) => (
  <span
    className={ cn(
      styles.presetTag,
      isActive && (activeClassName || styles.isActive),
      className,
    ) }
    onClick={ onClick }
    data-test={ dataTest }
  >
    { children }
  </span>
);

export default PresetTag;
